export { default } from './footer-legal';
